<div class="route_sign_post signpost_details">
  @for (road of roads; track trackByFn($index)) {
    <div class="prefix signposts">
      @if (road.Prefix.length) {
          @for (prefix of road.Prefix; track trackByFn($index)) {
              @if (prefix.icon) {
                <div class="{{'icon-'+prefix.icon}} signpost_prefix_icon middle"></div>
              }
              <div class="route_signPost_prefix">{{prefix.name}}</div>
          }
      }
    </div>
  }
  <div class="signpost_wrapper">
    @for (road of roads; track trackByFn($index)) {
      <div class="signposts">
        @if (road.Text.length) {
          <div class="display_text" >
            @for (text of road.Text; track trackByFn($index)) {
                <div class="signpost_text">{{text}}</div>
                @if (road.Icon) {
                  <div class="{{'icon-'+road.Icon}} signpost_icon"></div>
                }
            }
          </div>
        }
        @if (road.Name.length) {
          <div class="display_text">
            @for (name of road.Name; track trackByFn($index)) {
                <div class="{{getClassName(name)}}" [ngClass]="{'aa_local_roadway':road.Type == aa_local_roadway,'aa_type_motarway':road.Type == aa_type_motarway,'aa_type_place_of_interest':road.Type == aa_type_place_of_interest,'signspot-motorway':name.indexOf('M') != -1,'signspot-a-road':(name.indexOf('A') != -1 && road.Type != aa_type_place_of_interest)}">{{name}}</div>
            }
          </div>
        }
      </div>
    }
  </div>
  @for (road of roads; track trackByFn($index)) {
    <div class="suffix signposts">
      @if (road.Suffix.length) {
          @for (suffix of road.Suffix; track trackByFn($index)) {
              @if (suffix.icon) {
                <div class="{{'icon-'+suffix.icon}} signpost_suffix_icon middle"></div>
              }
              <div class="route_signPost_suffix">{{suffix.name}}</div>
          }
      }
    </div>
  }
</div>